import * as React from 'react';
import * as classNames from 'classnames';
import {StatelessComponent} from 'react';
import './styles.sass';

export interface ITextProps {
  children?: any;
  className?: string;
  justify?: boolean;
  center?: boolean;
}

export const Text: StatelessComponent<ITextProps>
  = ({children, className, center, justify = true}: ITextProps) => (
    <p className={classNames(
      'text', className, {'text_justify': justify, 'text_center': center},
    )}>
      {children}
    </p>
  );
